import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M15 5h2v10h10v2H17v10h-2V17H5v-2h10V5z" /></svg>);